export enum NotificationsTypeEnum {
  push = "push",
  email = "email",
}

export type NotificationTypeArray = NotificationsTypeEnum[];

export enum NotificationsDeliveryEnum {
  instant = "instant",
  scheduled = "scheduled",
  recurring = "recurring",
}

export enum NotificationsDeliveryPartEnum {
  delivery = "delivery",
  instant = "instant",
  scheduled = "scheduled",
}

export enum NotificationsDeliveryTabEnum {
  oneTime = "oneTime",
  recurring = "recurring",
  routeNotifications = "routeNotifications",
  automated = "automated",
  serviceAlerts = "serviceAlerts",
}

export enum NotificationsRecurrenceEnum {
  daily = "daily",
  weekly = "weekly",
  everyWeekday = "everyWeekday",
  monthly = "monthly",
  yearly = "yearly",
  custom = "custom",
}

export enum NotificationsRepeatEnum {
  day = "day",
  week = "week",
  month = "month",
  year = "year",
}

export enum NotificationsStatusEnum {
  draft = "draft",
  sent = "sent",
  notSent = "notSent",
}

export const notificationsTypeEnumValues = Object.values(NotificationsTypeEnum);
export const notificationsTypeEnumLabelMap: Record<
  NotificationsTypeEnum,
  string
> = {
  [NotificationsTypeEnum.email]: "Email",
  [NotificationsTypeEnum.push]: "Push",
};

export const notificationsDeliveryEnumValues = Object.values(
  NotificationsDeliveryEnum,
);

export const notificationsDeliveryEnumLabelMap: Record<
  NotificationsDeliveryEnum,
  string
> = {
  [NotificationsDeliveryEnum.instant]: "Instant",
  [NotificationsDeliveryEnum.scheduled]: "Scheduled",
  [NotificationsDeliveryEnum.recurring]: "Recurring",
};

export const notificationsDeliveryPartEnumValues = Object.values(
  NotificationsDeliveryPartEnum,
);

export const notificationsDeliveryPartEnumLabelMap: Record<
  NotificationsDeliveryPartEnum,
  string
> = {
  [NotificationsDeliveryPartEnum.delivery]: "Delivery",
  [NotificationsDeliveryPartEnum.instant]: "Instant",
  [NotificationsDeliveryPartEnum.scheduled]: "Scheduled",
};

export const notificationsDeliveryTabEnumValues = Object.values(
  NotificationsDeliveryTabEnum,
);

export const notificationsDeliveryTabEnumLabelMap: Record<
  NotificationsDeliveryTabEnum,
  string
> = {
  [NotificationsDeliveryTabEnum.oneTime]: "One-Time",
  [NotificationsDeliveryTabEnum.recurring]: "Recurring",
  [NotificationsDeliveryTabEnum.routeNotifications]: "Route Notifications",
  [NotificationsDeliveryTabEnum.automated]: "Automated",
  [NotificationsDeliveryTabEnum.serviceAlerts]: "Service Alerts",
};

export const notificationsDeliveryTabEnumFilterMap: Record<
  NotificationsDeliveryTabEnum,
  NotificationsDeliveryEnum[]
> = {
  [NotificationsDeliveryTabEnum.oneTime]: [
    NotificationsDeliveryEnum.instant,
    NotificationsDeliveryEnum.scheduled,
  ],
  [NotificationsDeliveryTabEnum.recurring]: [
    NotificationsDeliveryEnum.recurring,
  ],
  [NotificationsDeliveryTabEnum.routeNotifications]: [],
  [NotificationsDeliveryTabEnum.automated]: [
    NotificationsDeliveryEnum.recurring,
  ],
  [NotificationsDeliveryTabEnum.serviceAlerts]: [],
};

export const notificationsRecurrenceEnumValues = Object.values(
  NotificationsRecurrenceEnum,
);

export const notificationsRecurrenceEnumLabelMap: Record<
  NotificationsRecurrenceEnum,
  string
> = {
  [NotificationsRecurrenceEnum.daily]: "Daily",
  [NotificationsRecurrenceEnum.weekly]: "Weekly",
  [NotificationsRecurrenceEnum.monthly]: "Monthly",
  [NotificationsRecurrenceEnum.yearly]: "Annually",
  [NotificationsRecurrenceEnum.everyWeekday]:
    "Every weekday (Monday to Friday)",
  [NotificationsRecurrenceEnum.custom]: "Custom...",
};

export const notificationsRepeatEnumValues = Object.values(
  NotificationsRepeatEnum,
);

export const notificationsRepeatEnumLabelMap: Record<
  NotificationsRepeatEnum,
  string
> = {
  [NotificationsRepeatEnum.day]: "Day",
  [NotificationsRepeatEnum.week]: "Week",
  [NotificationsRepeatEnum.month]: "Month",
  [NotificationsRepeatEnum.year]: "Year",
};

export const notificationsStatusEnumValues = Object.values(
  NotificationsStatusEnum,
);

export const notificationsStatusEnumLabelMap: Record<
  NotificationsStatusEnum,
  string
> = {
  [NotificationsStatusEnum.draft]: "Draft",
  [NotificationsStatusEnum.sent]: "Sent",
  [NotificationsStatusEnum.notSent]: "Not Sent",
};

export const notificationsTypeSelectOptions = notificationsTypeEnumValues.map(
  (c) => ({
    label: notificationsTypeEnumLabelMap[c],
    value: c,
  }),
);

export const notificationsStatusSelectOptions =
  notificationsStatusEnumValues.map((c) => ({
    label: notificationsStatusEnumLabelMap[c],
    value: c,
  }));

export const notificationsDeliverySelectOptions =
  notificationsDeliveryEnumValues.map((c) => ({
    label: notificationsDeliveryEnumLabelMap[c],
    value: c,
  }));

export const notificationsDeliveryPartSelectOptions =
  notificationsDeliveryPartEnumValues.map((c) => ({
    label: notificationsDeliveryPartEnumLabelMap[c],
    value: c,
  }));

export const notificationsRecurrenceSelectOptions =
  notificationsRecurrenceEnumValues.map((c) => ({
    label: notificationsRecurrenceEnumLabelMap[c],
    value: c,
  }));

export const notificationsRepeatSelectOptions =
  notificationsRepeatEnumValues.map((c) => ({
    label: notificationsRepeatEnumLabelMap[c],
    value: c,
  }));

export enum NotificationsServiceAlertStatusEnum {
  sent = "sent",
  notSentYet = "notSentYet",
  all = "all",
}

export const notificationsServiceAlertStatusEnumLabelMap: Record<
  NotificationsServiceAlertStatusEnum,
  string
> = {
  [NotificationsServiceAlertStatusEnum.sent]: "Sent",
  [NotificationsServiceAlertStatusEnum.notSentYet]: "Not Sent",
  [NotificationsServiceAlertStatusEnum.all]: "All",
};

export const notificationsServiceAlertStatusEnumValues = Object.values(
  NotificationsServiceAlertStatusEnum,
);

export const notificationsServiceAlertStatusSelectOptions =
  notificationsServiceAlertStatusEnumValues.map((c) => ({
    label: notificationsServiceAlertStatusEnumLabelMap[c],
    value: c,
  }));
